import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getOutstandingBalanceInfoBalance } from "@fas/cpa-state-manager/services/selectors/outstandingBalanceInfo";
import { setOutstandingBalanceInfo } from "@fas/cpa-state-manager/redux/actions/outstandingBalanceInfo";
import { useHandleRequest } from "@fas/cpa-state-manager/redux/hooks";
import { setLoading } from "@fas/cpa-state-manager/redux/actions/loading";
import { getLoadingState } from "@fas/cpa-state-manager/services/selectors/loading";
import { OUTSTANDING_BALANCE } from "../../constants";
import { getOutstandingBalance } from "../../services/deprecatedApi";

export type UseOutstandingBalanceHook = {
  isLoading?: boolean;
  disabled?: boolean;
  balance: number;
  comment: string;
};

export const useOutstandingBalance = (): UseOutstandingBalanceHook => {
  const comment = "Outstanding balance";
  const balance = useSelector(getOutstandingBalanceInfoBalance);
  const dispatch = useDispatch();
  const isFetched = useSelector((state) =>
    getLoadingState(state, `${OUTSTANDING_BALANCE}-fetched`)
  );
  const { isLoading, changeLoading, onFail, onFinally } =
    useHandleRequest(OUTSTANDING_BALANCE);
  useEffect(() => {
    changeLoading(true);

    getOutstandingBalance()
      .then((newBalance) => {
        dispatch(
          setOutstandingBalanceInfo({
            balance: Number(newBalance.split("$")[1]),
          })
        );
        dispatch(setLoading(`${OUTSTANDING_BALANCE}-fetched`, true));
      })
      .catch(onFail)
      .finally(onFinally);
  }, []);

  return {
    isLoading: isLoading && !isFetched,
    balance,
    comment,
    disabled: isLoading,
  };
};
